import { Injectable } from '@angular/core';
import { CombeniaService } from '../services/CombeniaService/CombeniaService';
import { CombeniaItem } from '../services/CombeniaService/models/CombeniaItem';
import { CombeniaAttribute } from '../services/CombeniaService/models/CombeniaAttribute';
import { CombeniaCriteria } from '../services/CombeniaService/models/CombeniaCriteria';

export class MediaFilters {
    brands:Array<string>;
    types: Array<string>;
    from:string;
    to:string;
    offset:number;
    limit:number;
    order_column:string;
    sort:string;
    search:string;
}

@Injectable()
export class MediaModel {
    url: string;
    name: string;
    type: string;
    brand: string;
    creationTime: Date;
    modificationTime: Date;
    thumbUrl: string;

    constructor(public combenia: CombeniaService){}

    init(obj:any={}) {
        Object.assign(this, obj);

    }

    async getMediaComb(listOfMedia: Array<MediaModel>, filter:MediaFilters): Promise<any> {
        let criteria = new CombeniaCriteria();
        if(filter.types && filter.types.length > 0) {
          criteria.types = [];
          filter.types.forEach((el) => {
            criteria.types.push(el);
          })
        }
        if(filter.brands && filter.brands.length > 0) {
          let brands = [];
          filter.brands.forEach((el) => {
            brands.push(el);
          })
          criteria.attributes = [{name: 'brand', in: brands}];
        } 
        if((filter.from && filter.from != "") || (filter.to && filter.to != "")) {
          let lower = (filter.from && filter.from != "") ? filter.from : "1900-01-01T00:00:00.000";
          let upper = (filter.to && filter.to != "") ? filter.to : new Date().toISOString();
          criteria.attributes = [{range:{ type:"date",lower:lower,upper:upper},name:"modificationDate"}]
        }
        if(filter.search && filter.search != "") {
          criteria.attributes = [{name: 'title', value: filter.search}]
        }
        if(filter.order_column) {
          if(!criteria.types || criteria.types.length == 0) {
            criteria.types = ["document", "video"];
          }
          criteria.order = {
            name: filter.order_column,
            direction: filter.sort
          }
        }
        let res = await this.combenia.getMediaByCriteria(criteria, 0, -1);
        let items = <CombeniaItem[]> res["items"];
        items.forEach((item:CombeniaItem)=>{
          let media: MediaModel = new MediaModel(this.combenia);
          media.brand=this.getAttrValue(item, "brand");
          media.name = this.getAttrValue(item,"title");
          media.creationTime = item.creationTime;
          media.modificationTime = item.modificationTime;
          let url = '';
          if(item.type === 'image') {
            let image:CombeniaAttribute=this.getAttribute(item, "image");
            if(image) {
              url=image.value.url; 
            } 
          } else if(item.type === 'document') {
            let document:CombeniaAttribute = this.getAttribute(item, "document");
            if(document) {
              url=document.value.url;
            }
          } else if(item.type === 'video') {
            let video:CombeniaAttribute = this.getAttribute(item, "video");
            if(video) {
              url=video.value.url;
            }
          }
          media.url = url;
          media.type = item.type;
          let anteprima:CombeniaAttribute=this.getAttribute(item, "thumb");
          let anteprimaUrl = 'assets/image/Media_Placeholder.png';
          if(anteprima) {
            anteprimaUrl = anteprima.value.url;
          }
          media.thumbUrl = anteprimaUrl;
          listOfMedia.push(media);
        })
    }

    async getMedia(filter:MediaFilters):Promise<Array<MediaModel>> {
        let listOfMedia = new Array<MediaModel>();
        await this.getMediaComb(listOfMedia, filter);
        return listOfMedia;
    }

    async countMedia(filter) {
      let criteria = new CombeniaCriteria();
      if(filter.types && filter.types.length > 0) {
        criteria.types = [];
        filter.types.forEach((el) => {
          criteria.types.push(el);
        })
      }
      if(filter.brands && filter.brands.length > 0) {
        let brands = [];
        filter.brands.forEach((el) => {
          brands.push(el);
        })
        criteria.attributes = [{name: 'brand', in: brands}];
      } 
      if((filter.date_from && filter.date_from != "") || (filter.date_to && filter.date_to != "")) {
        
        let lower = (filter.date_from && filter.date_from != "") ? filter.date_from : "1900-01-01T00:00:00.000";
        let upper = (filter.date_to && filter.date_to != "") ? filter.date_to : new Date().toISOString();
        criteria.attributes = [{range:{ type:"date",lower:lower,upper:upper},name:"modificationDate"}]
      }
      let res = await this.combenia.getMediaByCriteria(criteria,0, -1);
      let items = <CombeniaItem[]> res;
      return items["count"];
    }

    getAttrValue(item: CombeniaItem, attrName:string){ 
      let finded= this.getAttribute(item, attrName);
      if(!finded)
        return null;
      return finded.value;
    }
    getAttribute(item: CombeniaItem, attrName:string){
      let finded= item.attributeList.find((a)=>{
        return a.name==attrName;
      })
      if(!finded)
        return null;  
      return finded;
  
    }
}